import { createListenerMiddleware } from '@reduxjs/toolkit';

import { appListeners } from './app';
import { authCredentialsListeners } from './authCredentials';

export const listenerMiddleware = createListenerMiddleware();

appListeners(listenerMiddleware);
authCredentialsListeners(listenerMiddleware);
